<template>
    <div>
        <el-form :model="landSearchFilter" ref="projectForm" :rules="rules" label-position="left"
            class="employer-ruleForm">
                <el-row>
                    <el-col :span="12" v-show="type == 2">
                        <el-form-item label="行业分类" prop="notionCode1" :label-width="labelWidth">
                            <el-select class="seletc-size-input-1" v-model="landSearchFilter.industry1" placeholder="请选择">
                                <el-option v-for="(item, index) in notionList1" :key="index" :value="item.paraValue"
                                    :label="item.paraName"></el-option>
                            </el-select>
                            <!-- <el-select class="seletc-size-input" v-model="landSearchFilter.industry2" placeholder="请选择">
                                <el-option v-for="(item, index) in notionList2" :key="index" :value="item.paraValue"
                                    :label="item.paraName"></el-option>
                            </el-select>
                            <el-select class="seletc-size-input" v-model="landSearchFilter.industry3" placeholder="请选择">
                                <el-option v-for="(item, index) in notionList3" :key="index" :value="item.paraValue"
                                    :label="item.paraName"></el-option>
                            </el-select> -->
                        </el-form-item>
                    </el-col>
                <el-col :span="12" v-show="type == 3">
                    <el-form-item label="企业类型" prop="notionCode1" :label-width="labelWidth">
                        <el-select  class="seletc-size-input-1" v-model="landSearchFilter.tagCode" placeholder="请选择">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in enterpriseTypeList" :key="index" :value="item.tagCode"
                                :label="item.tagName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-show="type==2">
                    <el-form-item label="行政区域" prop="area" :label-width="labelWidth">
                        <el-select class="seletc-size-input" v-model="landSearchFilter.province" placeholder="请选择"
                            @change="onProvinceChange('area', $event)">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item) in provinceList" :key="item.areaId"
                                :value="item.areaId" :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.city" placeholder="请选择"
                            @change="onCityChange('area', $event)" :disabled="landSearchFilter.province==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.cityList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.county" placeholder="请选择"
                            @change="onCountyChange('area', $event)" :disabled="landSearchFilter.city==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.countyList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-show="type == 1">
                <el-col :span="12">
                    <el-form-item label="项目名称" prop="projectName" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.projectName" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资主体" prop="investor" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.investor" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="面积（亩）" prop="size1" :label-width="labelWidth">
                        <el-input class="num-size-input" v-model="landSearchFilter.size1" placeholder=""></el-input>
                        -
                        <el-input class="num-size-input" v-model="landSearchFilter.size2" placeholder=""></el-input>
                        （亩）
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="容积率上线" prop="volume1" :label-width="labelWidth">
                        <el-input class="num-size-input" v-model="landSearchFilter.volume1"
                            placeholder=""></el-input>
                        -
                        <el-input class="num-size-input" v-model="landSearchFilter.volume2"
                            placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="合同签订时间" prop="contractTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" size="large" v-model="landSearchFilter.contractTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.contractTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="约定支付时间" prop="payTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.payTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="landSearchFilter.payTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="约定交地时间" prop="deliveryTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.deliveryTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.deliveryTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="约定开工时间" prop="startTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.startTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.startTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" v-show="type!=2">
                    <el-form-item label="行政区域" prop="area" :label-width="labelWidth">
                        <el-select class="seletc-size-input" v-model="landSearchFilter.province" placeholder="请选择"
                            @change="onProvinceChange('area', $event)">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item) in provinceList" :key="item.areaId"
                                :value="item.areaId" :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.city" placeholder="请选择"
                            @change="onCityChange('area', $event)" :disabled="landSearchFilter.province==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.cityList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.county" placeholder="请选择"
                            @change="onCountyChange('area', $event)" :disabled="landSearchFilter.city==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.countyList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-show="type!=2">
                    <el-form-item label="行业分类" prop="notionCode1" :label-width="labelWidth">
                        <el-select class="seletc-size-input-1" v-model="landSearchFilter.industry1" placeholder="请选择">
                            <el-option v-for="(item, index) in notionList1" :key="index" :value="item.paraValue"
                                :label="item.paraName"></el-option>
                        </el-select>
                        <!-- <el-select class="seletc-size-input" v-model="landSearchFilter.industry2" placeholder="请选择">
                            <el-option v-for="(item, index) in notionList2" :key="index" :value="item.paraValue"
                                :label="item.paraName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.industry3" placeholder="请选择">
                            <el-option v-for="(item, index) in notionList3" :key="index" :value="item.paraValue"
                                :label="item.paraName"></el-option>
                        </el-select> -->
                    </el-form-item>
                </el-col>
                
            </el-row>
           
        </el-form>
        <div class="btn oh mr-8 mb-2">
            <div class="fr">
                <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
                <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { dataInJs } from "@/utils/city.js";
export default {
    name: 'landFilterCom',
    data() {
        return {
            labelWidth: '120px',
            rules: {},
            provincedata: dataInJs(),
            landSearchFilter: {
                tagCode: '',
                isCountyList: false,
                contractTime1: '',
                contractTime2: '',
                payTime1: '',
                payTime2: '',
                deliveryTime1: '',
                deliveryTime2: '',
                startTime1: '',
                startTime2: '',
                province: '',
                city: '',
                county: '',
                countyList: [],
                sourceProvince: '',
                sourceCity: '',
                sourceCounty: '',
                industry1: '',
                industry2: '',
                industry3: '',
                landType1: '',
                landType2: '',
                size1: '',
                size2: '',
                price1: '',
                price2: '',
                volume1: '',
                volume2: '',
                useYears: '',
                supplyMode1: '',
                supplyMode2: '',
                landLevel: '',
                projectName: '',
                location: '',
                owner: '',
                investor: '',
                sourceExclude: false,

            },
            provinceList: dataInJs(),
            lists: {
                area: {
                    cityList: [],
                    countyList: []
                },
                source: {
                    cityList: [],
                    countyList: []
                }
            },
            cityList: [
                { value: '1', label: '保定' },
                { value: '2', label: '北京' },
                { value: '3', label: '石家庄' },
            ],
            countyList: [
                { value: '1', label: '东城区' },
                { value: '2', label: '西城区' },
                { value: '3', label: '海淀区' },
                { value: '4', label: '朝阳区' },
                { value: '5', label: '丰台区' },
                { value: '6', label: '石景山区' },
            ],
            bigLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            smallLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            notionList1: [],
            notionList2: [],
            notionList3: [],
            landTypeList: [],
            landTypeList2: [],
            enterpriseTypeList: [
                { tagCode: "A020131", type: 'ss', fwb: true, tagName: "央企", },
                { tagCode: "A020104", type: 'ss', tagName: "国有企业", },
                { tagCode: "A090109", type: 'ss', fwb: true, tagName: "中国500强", },
                { tagCode: "A090110", type: 'ss', fwb: true, tagName: "中国民营企业500强", },
                { tagCode: "A090106", type: 'ss', fwb: true, tagName: "制造业单项冠军", },
                { tagCode: "A090103", type: 'lt', tagName: "专精特新小巨人企业", },
            ],
        }
    },
    props: {
        type: {
            type: Number,
            default: 1, //1拿地项目库 2监测线索管理
        }
    },
    created() {
    },
    mounted() {
        this.getIndustryList();
    },
    methods: {
        countyListChange(value) {
            console.log(value);
            // return
            // this.landSearchFilter.countyList = value.join(',');
            console.log(this.landSearchFilter.countyList);
        },
        onProvinceChange(target, value) {
            // 清理对应字段
            if (target === 'area') {
                this.landSearchFilter.province = value;
                this.landSearchFilter.city = '';
                this.landSearchFilter.county = '';
            } else {
                this.landSearchFilter.sourceProvince = value;
                this.landSearchFilter.sourceCity = '';
                this.landSearchFilter.sourceCounty = '';
            }

            // 根据省获取城市
            const selectedProvince = this.provinceList.find(item => item.areaId === value);
            if (selectedProvince && selectedProvince.children) {
                this.lists[target].cityList = selectedProvince.children;
            } else {
                this.lists[target].cityList = [];
            }
            // 清空县列表
            this.lists[target].countyList = [];
        },

        onCityChange(target, value) {
            // 清理对应县及设置 city
            if (target === 'area') {
                this.landSearchFilter.city = value;
                this.landSearchFilter.county = '';
            } else {
                this.landSearchFilter.sourceCity = value;
                this.landSearchFilter.sourceCounty = '';
            }

            // 根据 city 获取 county
            const selectedCity = this.lists[target].cityList.find(item => item.areaId === value);
            if (selectedCity && selectedCity.children) {
                this.lists[target].countyList = selectedCity.children;
            } else {
                this.lists[target].countyList = [];
            }
        },

        onCountyChange(target, value) {
            if (target === 'area') {
                this.landSearchFilter.county = value;
            } else {
                this.landSearchFilter.sourceCounty = value;
            }
        },
        search() {
            // console.log(this.landSearchFilter);
            this.$emit('search', this.landSearchFilter);
        },
        //获取行业分类
        getIndustryList() { 
            this.$axios.get(this.$api.metall.LandParam.KeyIndustry()).then((res) => {
               if (res.data.success) { 
                this.notionList1 = res.data.list;
               } else {
                   this.$message.error(res.data.message);
               }
           })
        },
        reset() {
            // 重置所有筛选项并清空两个目标的城市/区县列表
            this.landSearchFilter = {
                tagCode: '',
                isCountyList: false,
                contractTime1: '',
                contractTime2: '',
                payTime1: '',
                payTime2: '',
                deliveryTime1: '',
                deliveryTime2: '',
                startTime1: '',
                startTime2: '',
                province: '',
                city: '',
                county: '',
                countyList: [],
                sourceProvince: '',
                sourceCity: '',
                sourceCounty: '',
                industry1: '',
                industry2: '',
                industry3: '',
                landType1: '',
                landType2: '',
                size1: '',
                size2: '',
                price1: '',
                price2: '',
                volume1: '',
                volume2: '',
                useYears: '',
                supplyMode1: '',
                supplyMode2: '',
                landLevel: '',
                projectName: '',
                location: '',
                owner: '',
                investor: '',
                sourceExclude: false,
            }
            this.lists.area.cityList = [];
            this.lists.area.countyList = [];
            this.lists.source.cityList = [];
            this.lists.source.countyList = [];
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .text-input {
        width: 70%
    }

    .el-input__inner {
        font-size: 14px;
        // line-height: 80px;
        height: 38px;
    }

    .el-form-item__label {
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }

    .num-size-input {
        width:228px;
    }

    .seletc-size-input {
        width: 140px;
    }
    .seletc-size-input-2 {
        width: 220px;
    }
    .seletc-size-input-1 {
        width: 470px;
    }
}
</style>